export const InstaladoresBuscaEntity = {
    cupom:''
}